<template>
  <illustration-layout :cclink="$store.state.cclink + 'SPECIALISTS'">
    <div style="text-align:center;border-bottom:1px solid #7a7157;padding:35px 0;margin:0 35px">
      <div style="color:#101820;font-size:40px">
        Style Specialists
      </div>
      <div style="color:#ce0e2d;font-weight:500;font-size:52px;letter-spacing:-1px;margin-bottom:25px">
        {{ item.title }}
      </div>
      <div v-if="item.intro" style="color:#000;margin-bottom:20px">
        {{ item.intro }}
      </div>
      <style-specialist-panel v-for="artist in item.artists" :key="artist.portfolio_url" :artist="artist" />
    </div>
  </illustration-layout>
</template>

<script>
import NewTalentLoader from '../mixins/NewTalentLoader'
import StyleSpecialistPanel from '../components/StyleSpecialistPanel'
import IllustrationLayout from '../layouts/IllustrationLayout.vue'
export default {
  mixins: [ NewTalentLoader ],
  components: {
    StyleSpecialistPanel,
    IllustrationLayout
  }
}
</script>

<style>

</style>